import http from "@/http-common";

class MiscService{
    getBackendVersion(){
        return http.get(`/misc/version`);
    }
}


export default new MiscService();